module.exports = __webpack_public_path__ + "static/media/checkout-instore-active.f41303a4.svg";